import {
  REACT_APP_ENV_MAP,
  TerminalType,
  bootstrap as coreBootstrap,
  isBiz,
  lx,
  getSearch,
  ACCOUNT_TYPE,
  getFrom,
} from '@cap/rzmt-core';
import { isBrowser } from '@cap/ssr-common-utils';

export const appEnv = process.env.REACT_APP_ENV as REACT_APP_ENV_MAP;
/**
 *
 * @param href 包含域名的url地址，如：window.location.origin 或者 window.location.href
 * @returns
 */
export const getAccountType = (href: string) => (isBiz(href) ? ACCOUNT_TYPE.EPASSPORT : ACCOUNT_TYPE.PASSPORT);
export const terminalType = (process.env.REACT_APP_TerminalType ?? TerminalType.Mobile) as unknown as TerminalType;
export const swimlane = process.env.SWIMLANE;

export default function bootstrap(options: { lxCustom: Record<string, any>; href: string }) {
  const { lxCustom, href } = options || {};
  const { source } = getSearch(href);
  const accountType = getAccountType(href);
  // 因为支持外包直接组件接入报名表单，所以需要一个全局的环境信息引导入口
  coreBootstrap({
    env: appEnv,
    terminalType,
    accountType,
    swimlane: process.env.SWIMLANE,
    source: source as string,
  });
  if (!isBrowser) return;
  // 埋点公用参数
  lx.initLx({
    env: appEnv,
    accountType,
    defaultCustom: {
      systemName: 'mddc_portal',
      platform: 'web',
      src_app_name: getFrom(),
      source: (source || 'unknown') as string,
      ...lxCustom,
    },
    defaultValLab: {},
  });
}
